import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import CustomersModalCustomer from '../../components/CustomersModalCustomer/CustomersModalCustomer';
import { customerModalStore } from '../../store';
import { ICustomersModalItem } from '../../types';
import { localeStore } from 'src/mobx/localesStore';
import { arrayMerge } from 'src/utils/formatter';
import { emptyArray } from 'src/utils/helpers';

const CustomersModalCustomers: FC = observer((): JSX.Element => {
  const {
    loading,
    searchValue,
    isSelectedCrumb,
    isEmptyThisAll,
    selectedCustomers,
    alreadySelectedUnavailableCustomers,
    pagination,
    checkIncludeInFilter,
  } = customerModalStore;

  const _selectedCustomers = useMemo(() => {
    let array: ICustomersModalItem[] = [];

    switch (true) {
      case isEmptyThisAll && pagination.current_page === pagination.last_page:
        array = arrayMerge(pagination.data, alreadySelectedUnavailableCustomers, 'id');
        break;
      case isEmptyThisAll:
        array = pagination.data;
        break;
      default:
        array = arrayMerge(selectedCustomers, alreadySelectedUnavailableCustomers, 'id');
        break;
    }

    return array.filter((customer) => checkIncludeInFilter(customer));
  }, [isEmptyThisAll, selectedCustomers, alreadySelectedUnavailableCustomers, searchValue, pagination]);

  const customersForRender = useMemo(() => {
    return isSelectedCrumb ? _selectedCustomers : pagination.data;
  }, [isSelectedCrumb, _selectedCustomers, pagination.data]);

  if (loading) {
    return (
      <>
        {emptyArray().map((_, index) => (
          <CustomersModalCustomer key={'key-' + String(index)} />
        ))}
      </>
    );
  }

  if (!customersForRender.length) {
    return (
      <div className="d-flex full-height full-width align-items-center">
        <p className="family-bold text-size-26 color-dark mx-auto my-auto">{localeStore.t('customers_not_found')}</p>
      </div>
    );
  }

  return (
    <>
      {customersForRender.map((customer) => (
        <CustomersModalCustomer key={customer.id} customer={customer} />
      ))}
    </>
  );
});

export default CustomersModalCustomers;
